import { makeStyles } from '@mui/styles'
import { hexToRgba } from '../../../../utils/commonUtils'

export default makeStyles((theme: any) => ({
    PatientFormBodySection: {
        borderBottom: `2px solid ${theme.palette.lightGrey.dark}`,
        paddingBottom: '1.5rem',
    },
    PatientFormBodySectionContainer: {
        position: 'relative',
        zIndex: 150,
    },
    PatientFormBodySectionHighlighted: {
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            zIndex: 10,
            transform: 'scale(1.03, 1.2)',
            borderRadius: '1rem',
        },
    },
    PatientFormBodySectionHighlightedWarning: {
        '&::before': {
            background: hexToRgba(theme.palette.orangeWarning.main, 0.05),
            outline: `solid ${hexToRgba(theme.palette.orangeWarning.main, 0.12)}`,
        },
    },
    PatientFormBodySectionHighlightedError: {
        '&::before': {
            background: hexToRgba(theme.palette.error.main, 0.12),
            outline: `solid ${hexToRgba(theme.palette.error.main, 0.3)}`,
        },
    },
    PatientFormBodySectionTitleContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '.7rem',
        marginBottom: '1rem',
    },
    PatientFormBodySectionTitle: {
        fontSize: '1.3rem',
        fontWeight: '700',
    },
    PatientFormBodySectionTitleNotification: {
        width: '.75rem',
        height: '.75rem',
        borderRadius: '100%',
        background: theme.palette.lightGrey.dark,
        alignSelf: 'flex-start',
        flexShrink: 0,
    },
    PatientFormBodySectionTitleNotificationWarning: {
        background: theme.palette.orangeWarning.main,
    },
    PatientFormBodySectionTitleNotificationError: {
        background: theme.palette.error.main,
    },
    PatientFormBodySectionContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: '1rem',
    },
    PatientFormBodySectionContentItem: {},
}))
